import Secure from './Secure';

export default Secure;



// WEBPACK FOOTER //
// ./src/views/Secure/index.js